import React from "react";

import {
  RideModal,
  RideModalContent,
} from "@rimac-seguros/ride-system-components";

import Accordion from "@/components/molecules/CustomAccordion/index";
import useBreakpoint from "@/hooks/useBreakpoint";

import "./styles.scss";
import helpers from "@/utils/helpers";
import { getProductOptions } from "@/utils/product";

export const ModalQuestionList = ({ questions = [], isOpen, setIsOpen }) => {
  const isVE = helpers.validateVidaEndosable();
  const { digitalDataProductName } = getProductOptions();
  const isDesktop = useBreakpoint("large-min");
  const isTablet = useBreakpoint("tablet");

  const handleQuestionClick = (isOpen, question) => {
    if (isVE && isOpen) {
      helpers.setActionTag({
        group: digitalDataProductName,
        category: "Dudas frecuentes",
        action: "click",
        label: question,
      });
    }
  };

  return (
    <RideModal
      variant="new"
      size="medium"
      isOpen={isOpen}
      onOpenChange={setIsOpen}
      fullScreen={!isTablet && !isDesktop}
    >
      <RideModalContent className="scroll-stable">
        <div className="section-questions-modal_content">
          <div className="section-questions-modal_content-group">
            {questions?.map((_, i) => (
              <Accordion
                key={`question-${i}`}
                icon={_.icon}
                label={_.question}
                lastItem={i === questions.length - 1}
                onClick={(isOpen) => handleQuestionClick(isOpen, _.question)}
              >
                <div
                  className="section-questions-modal_content-accordion"
                  dangerouslySetInnerHTML={{ __html: _.answer }}
                />
              </Accordion>
            ))}
          </div>
        </div>
      </RideModalContent>
    </RideModal>
  );
};
